import { M8PartnerStatus } from 'services/production/types';
import { PartnerStatus } from 'types/state';

export const normalizeM8PartnerStatus = (m8PartnerStatus: M8PartnerStatus) => ({
  toPartnerStatus(): PartnerStatus {
    switch (m8PartnerStatus) {
      case 'ACTIVE':
        return 'ACTIVE';
      case 'BLOCKED':
        return 'DISABLED';
      case 'REGISTRATION':
        return 'CANDIDATE';
    }
  },
});
